<template>
  <div class="bg-white">
    <div class="container">
      <div class="row justify-content-center align-items-center d-flex vh-100">
        <div class="col-lg-4 mx-auto">
          <div class="osahan-login py-4">
            <div class="text-center mb-4">
              <!-- <a href="index.html"><img src="images/fav.svg" alt=""/></a> -->
              <h5 class="font-weight-bold mt-3">First, let's find your account</h5>
              <p class="text-muted">Please enter your email and answer your security question</p>
            </div>
            <form action="index.html">
              <div class="form-group">
                <label class="mb-1" for="email">Email</label>
                <div class="position-relative icon-form-control ">
                  <i class="mdi mdi-account position-absolute icon--big"></i>
                  <input type="email" class="form-control input-font-size" />
                </div>
              </div>
              <div class="form-group">
                <label class="mb-1" for="text">
                  Security Question: <b>{{ securityQuestion }}</b>
                </label>
                <div class="position-relative icon-form-control ">
                  <i class="mdi mdi-shield-lock position-absolute icon--big"></i>
                  <input type="text" class="form-control input-font-size" />
                </div>
              </div>
              <button class="btn btn-success btn-block  btn-custom" type="submit"> Send Password Reset Code </button>
              <div class="py-3 d-flex align-item-center">
                <router-link tag="a" to="/login">Sign In</router-link>
                <span class="ml-auto"> New to Miver? <router-link tag="a" to="/register">Join now</router-link></span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: function() {
      return {
        securityQuestion: 'What is the name of your favourite song?',
      };
    },
  };
</script>

<style scoped>
  input[type='email'],
  input[type='text'],
  input[type='tel'],
  input[type='password'] {
    padding: var(--input-register-padding);
  }

  button {
    padding: var(--btn-padding);
    font-size: var(--btn-font-size);
  }
</style>
